import { AVATAR_PALETTES, type AvatarPalette } from "./avatarPalettes";
import { AVATAR_PATTERNS, type AvatarPatternName, type AvatarShape } from "./avatarPatterns";
import { seededRandom } from "./seededRandom";

/** A generated avatar: a palette, a pattern's shapes and the turn they are drawn at. */
export interface AvatarArt {
  readonly pattern: AvatarPatternName;
  readonly palette: AvatarPalette;
  readonly turn: number;
  readonly shapes: readonly AvatarShape[];
}

/** The avatar a seed stands for (F14): pure, so the same seed always draws the same picture. */
export function generateAvatar(seed: string): AvatarArt {
  const random = seededRandom(seed);
  const palette = random.pick(AVATAR_PALETTES);
  const pattern = random.pick(AVATAR_PATTERNS);
  const turn = Math.round(random.between(...pattern.turn));
  return { pattern: pattern.name, palette, turn, shapes: pattern.draw(random) };
}
